/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    asset: "I. Lưu chuyển tiền từ hoạt động kinh doanh",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "01",
    asset: "1. Lợi nhuận trước Thuế nhu nhập doanh nghiệp",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "02",
    asset: "2. Điều chỉnh cho các khoản (02=03+04+05+06+07+08+09)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "03",
    asset: "- Khấu hao TSCĐ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "04",
    asset: "- Các khoản dự phòng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "05",
    asset: "(-Lãi) hoặc (+Lỗ) chênh lệch tỷ giá hối đoái chưa thực hiện",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "06",
    asset: "- Chi phí lãi vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "07",
    asset: "Lãi, lỗ từ hoạt động đầu tư",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "08",
    asset: "- Dự thu tiền lãi",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "09",
    asset: "- Các khoản điều chỉnh khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "10",
    asset: "3. Tăng các chi phí phi tiền tệ (10=11+12+13+14+15+16+17)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "11",
    asset: "- Lỗ đánh giá lại giá trị các tài sản tài chính ghi nhận thông qua lãi/lỗ FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "12",
    asset: "- Lỗ suy giảm giá trị Các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "13",
    asset: "- Lỗ suy giảm giá trị Các khoản cho vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "14",
    asset:
      "- Lỗ về ghi nhận chênh lệch đánh giá theo giá trị hợp lý TSTC sẵn sàng để bán AFS khi phân loại lại",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "15",
    asset: "- Suy giảm giá trị của các tài sản cố định, BĐSĐT",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "16",
    asset: "- Chi phí dự phòng suy giảm giá trị các khoản đầu tư tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "17",
    asset: "- Lỗ khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "18",
    asset: "4. Giảm các doanh thu phi tiền tệ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "19",
    asset: "- Lãi đánh giá lại giá trị các tài sản tài chính ghi nhận thông qua lãi/lỗ FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "20",
    asset:
      "- Lãi về ghi nhận chênh lệch đánh giá theo giá trị hợp lý TSTC sẵn sàng để bán (AFS) khi phân loại lại",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "21",
    asset: "- Lãi khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "30",
    asset: "5. Lợi nhuận từ hoạt động kinh doanh trước thay đổi vốn lưu động (30=01+02+10+18)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "31",
    asset: "- Tăng (giảm) tài sản tài chính ghi nhận thông qua lãi/lỗ FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "32",
    asset: "- Tăng (giảm) Các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "33",
    asset: "- Tăng (giảm) Các khoản cho vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "34",
    asset: "- Tăng (giảm) tài sản tài chính sẵn sàng để bán AFS",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "35",
    asset: "(-) Tăng,(+) giảm phải thu bán các tài sản tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "36",
    asset: "(-) Tăng,(+) giảm phải thu và dự thu cổ tức, tiền lãi các tài sản tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "37",
    asset: "(-) Tăng,(+) giảm các khoản phải thu các dịch vụ CTCK cung cấp",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "38",
    asset: "(-) Tăng,(+) giảm các khoản phải thu về lỗi giao dịch các TSTC",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "39",
    asset: "(-) Tăng,(+) giảm các khoản phải thu khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "40",
    asset: "- Tăng (giảm) các tài sản khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "41",
    asset: "- Tăng (giảm) chi phí phải trả (không bao gồm chi phí lãi vay)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "42",
    asset: "- Tăng (giảm) chi phí trả trước",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "43",
    asset: "(-) Thuế TNDN đã nộp",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "44",
    asset: "(-) Lãi vay đã trả",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "45",
    asset: "- Tăng (giảm) phải trả cho người bán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "46",
    asset: "- Tăng (giảm) các khoản trích nộp phúc lợi nhân viên",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 39,
    stt: "47",
    asset: "- Tăng (giảm) thuế và các khoản phải nộp Nhà nước (Không bao gồm thuế TNDN đã nộp)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "48",
    asset: "- Tăng (giảm) phải trả người lao động",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 41,
    stt: "49",
    asset: "- Tăng (giảm) phải trả về lỗi giao dịch các TSTC",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 42,
    stt: "50",
    asset: "- Tăng (giảm) phải trả, phải nộp khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 43,
    stt: "51",
    asset: "- Tiền thu khác từ hoạt động kinh doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 44,
    stt: "52",
    asset: "- Tiền chi khác cho hoạt động kinh doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 45,
    stt: "60",
    asset: "Lưu chuyển tiền thuần từ hoạt động kinh doanh (60=30+31+...+51+52)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 46,
    stt: "",
    asset: "II. Lưu chuyển tiền từ hoạt động đầu tư",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 47,
    stt: "61",
    asset: "1. Tiền chi để mua sắm, xây dựng TSCĐ, BĐSĐT và các tài sản khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 48,
    stt: "62",
    asset: "2. Tiền thu từ thanh lý, nhượng bán TSCĐ, BĐSĐT và các tài sản khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 49,
    stt: "63",
    asset: "3. Tiền chi đầu tư vốn vào công ty con, công ty liên doanh, liên kết và đầu tư khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 50,
    stt: "64",
    asset:
      "4. Tiền thu hồi các khoản đầu tư vào công ty con, công ty liên doanh, liên kết và đầu tư khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 51,
    stt: "65",
    asset: "5. Tiền thu về cổ tức và lợi nhuận được chia từ các khoản đầu tư tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 52,
    stt: "70",
    asset: "Lưu chuyển tiền thuần từ hoạt động đầu tư",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 53,
    stt: "",
    asset: "III. Lưu chuyển tiền từ hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 54,
    stt: "71",
    asset: "1. Tiền thu từ phát hành cổ phiếu, nhận vốn góp của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 55,
    stt: "72",
    asset: "2. Tiền chi trả vốn góp cho chủ sở hữu, mua lại cổ phiếu phát hành",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 56,
    stt: "73",
    asset: "3. Tiền vay gốc",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 57,
    stt: "73.1",
    asset: "3.1. Tiền vay Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 58,
    stt: "73.2",
    asset: "3.2. Tiền vay khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 59,
    stt: "74",
    asset: "4. Tiền chi trả nợ gốc vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 60,
    stt: "74.1",
    asset: "4.1. Tiền chi trả gốc vay Quỹ hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 61,
    stt: "74.2",
    asset: "4.2. Tiền chi trả nợ gốc vay tài sản tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 62,
    stt: "74.3",
    asset: "4.3. Tiền chi trả gốc vay khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 63,
    stt: "75",
    asset: "5. Tiền chi trả nợ gốc thuê tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 64,
    stt: "76",
    asset: "6. Cổ tức, lợi nhuận đã trả cho chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 65,
    stt: "80",
    asset: "Lưu chuyển tiền thuần từ hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 66,
    stt: "90",
    asset: "IV. Tăng/ giảm tiền thuần trong kỳ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 67,
    stt: "101",
    asset: "V. Tiền và các khoản tương đương tiền đầu kỳ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 68,
    stt: "101.1",
    asset: "- Tiền ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 69,
    stt: "101.2",
    asset: "- Các khoản tương đương tiền ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 70,
    stt: "102",
    asset: "- Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 71,
    stt: "103",
    asset: "VI. Tiền và các khoản tương đương tiền cuối kỳ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 72,
    stt: "103.1",
    asset: "- Tiền ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 73,
    stt: "103.2",
    asset: "- Các khoản tương đương tiền ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 74,
    stt: "104",
    asset: "- Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
];
const dataTable2 = [
  {
    id: 0,
    stt: "",
    asset: "I. Lưu chuyển tiền từ hoạt động môi giới, ủy thác của khách hàng",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "01",
    asset: "1. Tiền thu bán chứng khoán môi giới cho khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "02",
    asset: "2. Tiền chi mua chứng khoán môi giới cho khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "03",
    asset: "3. Tiền thu bán chứng khoán ủy thác của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "04",
    asset: "4. Tiền chi mua chứng khoán ủy thác của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "05",
    asset: "5. Thu vay Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "06",
    asset: "6. Chi trả vay Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "07",
    asset: "7. Nhận tiền gửi để thanh toán giao dịch chứng khoán của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "08",
    asset: "8. Chi trả thanh toán giao dịch chứng khoán của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "09",
    asset: "9. Nhận tiền gửi của Nhà đầu tư cho hoạt động ủy thác đầu tư của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "10",
    asset: "10. Chi trả cho hoạt động ủy thác đầu tư của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "11",
    asset: "11. Chi trả phí lưu ký chứng khoán của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "12",
    asset: "12. Thu lỗi giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "13",
    asset: "13. Chi lỗi giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "14",
    asset: "14. Tiền thu của Tổ chức phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "15",
    asset: "15. Tiền chi trả Tổ chức phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "20",
    asset: "Tăng/giảm tiền thuần trong kỳ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "30",
    asset: "II. Tiền và các khoản tương đương tiền đầu kỳ của khách hàng",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "31",
    asset: "Tiền gửi ngân hàng đầu kỳ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "32",
    asset:
      "- Tiền gửi của Nhà đầu tư về giao dịch chứng khoán theo phương thức CTCK quản lý. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "33",
    asset: "- Tiền gửi bù trừ và thanh toán giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "34",
    asset: "- Tiền gửi tổng hợp giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "35",
    asset: "- Tiền gửi của tổ chức phát hành. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "36",
    asset: "Các khoản tương đương tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "37",
    asset: "Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "40",
    asset: "III. Tiền và các khoản tương đương tiền cuối kỳ của khách hàng (40=20+30)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "41",
    asset: "Tiền gửi ngân hàng cuối kỳ:",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "42",
    asset:
      "- Tiền gửi của Nhà đầu tư về giao dịch chứng khoán theo phương thức CTCK quản lý. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "43",
    asset: "- Tiền gửi tổng hợp giao dịch chứng khoán cho khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "44",
    asset: "- Tiền gửi bù trừ và thanh toán giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "45",
    asset: "- Tiền gửi của tổ chức phát hành. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "46",
    asset: "Các khoản tương đương tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "47",
    asset: "Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
];
function Table4({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [data2, setData2] = useState(dataTable2);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };
  const handleChange2 = (values) => {
    const { id, name, value } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data2);
  };
  return (
    <>
      <Box display="flex" flexDirection="column" mt={5}>
        <Box display="flex" justifyContent="flex-end">
          <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
            Đơn vị tiền: Đồng Việt Nam
          </Typography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
                <Th style={{ textAlign: "center" }}>Mã số</Th>
                <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
                <Th style={{ textAlign: "center" }}>Năm nay</Th>
                <Th style={{ textAlign: "center" }}>Năm trước</Th>
              </tr>

              <tr>
                <Th style={{ textAlign: "center" }}>A</Th>
                <Th style={{ textAlign: "center" }}>B</Th>
                <Th style={{ textAlign: "center" }}>C</Th>
                <Th style={{ textAlign: "center" }}>1</Th>
                <Th style={{ textAlign: "center" }}>2</Th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((rows) => (
                  <tr key={rows.id}>
                    <Td
                      style={{
                        textAlign:
                          rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.assetBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.asset}
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.sttBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.stt}
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.presentBold === true ? "bold" : 400,
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="present"
                        readOnly={rows.presentReadOnly}
                        value={rows.value.present}
                        onChange={handleChange}
                        fontWeight={rows.presentBold}
                      />
                    </Td>
                    {rows.valueCenter && rows.valueCenter === true ? (
                      <>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.now}
                        </Td>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.before}
                        </Td>
                      </>
                    ) : (
                      <>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="now"
                            readOnly={rows.readOnly}
                            value={rows.value.now}
                            onChange={handleChange}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="before"
                            readOnly={rows.readOnly}
                            value={rows.value.before}
                            onChange={handleChange}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                      </>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </Box>
        {/* <Footer formData={formData} /> */}
      </Box>
      <Box display="flex" flexDirection="column" mt={5}>
        <Box textAlign="center">
          <Typography variant="h5" textTransform="uppercase">
            Phần lưu chuyển tiền tệ hoạt động môi giới, ủy thác của khách hàng
          </Typography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
                <Th style={{ textAlign: "center" }}>Mã số</Th>
                <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
                <Th style={{ textAlign: "center" }}>Năm nay</Th>
                <Th style={{ textAlign: "center" }}>Năm trước</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>1</Th>
                <Th style={{ textAlign: "center" }}>2</Th>
                <Th style={{ textAlign: "center" }}>3</Th>
                <Th style={{ textAlign: "center" }}>4</Th>
                <Th style={{ textAlign: "center" }}>5</Th>
              </tr>
            </thead>
            <tbody>
              {data2 &&
                data2.length > 0 &&
                data2.map((rows) => (
                  <tr key={rows.id}>
                    <Td
                      style={{
                        textAlign:
                          rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.assetBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.asset}
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.sttBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.stt}
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.presentBold === true ? "bold" : 400,
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="present"
                        readOnly={rows.presentReadOnly}
                        value={rows.value.present}
                        onChange={handleChange2}
                        fontWeight={rows.presentBold}
                      />
                    </Td>
                    {rows.valueCenter && rows.valueCenter === true ? (
                      <>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.now}
                        </Td>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.before}
                        </Td>
                      </>
                    ) : (
                      <>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="now"
                            readOnly={rows.readOnly}
                            value={rows.value.now}
                            onChange={handleChange2}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="before"
                            readOnly={rows.readOnly}
                            value={rows.value.before}
                            onChange={handleChange2}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                      </>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </Box>
        {/* <Footer formData={formData} /> */}
      </Box>
    </>
  );
}

export default memo(Table4);

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
